<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Tournaments">
          <div class="row">
            <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-trophy"></i> Tournaments
        </div>
        <div class="card-body">
          <!-- FILTERS -->
          <div class="card mb-3">
            <div class="card-header" (click)="isFilterOpen = !isFilterOpen" style="cursor:pointer">
              <i class="fa fa-filter"></i> Filtres
              <div class="pull-right">
                @if (isFilterOpen) {
                  <i class="fa fa-chevron-down"></i>
                } @else {
                  <i class="fa fa-chevron-left"></i>
                }
              </div>
            </div>
            <div class="card-body" [collapse]="!isFilterOpen">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Start Date (min)</label>
                    <input class="form-control" type="date" [(ngModel)]="startDateMinFilter">
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Start Date (max)</label>
                    <input class="form-control" type="date" [(ngModel)]="startDateMaxFilter">
                  </div>
                </div>
              </div>
              <div class="filters-buttons">
                <button [disabled]="isLoading" class="btn btn-sm btn-primary" (click)="onClickFilter()"><i class="fa fa-filter"></i> Filter</button>
                <button [disabled]="isLoading" class="btn btn-sm btn-danger" (click)="onClickResetFilters()"><i class="fa fa-ban"></i> Reset</button>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <button class="btn btn-sm btn-primary me-2" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Tournament
            </button>
            <button class="btn btn-sm btn-success" type="button" (click)="onClickAddFromFile()" [disabled]="isLoading">
              <i class="fa fa-upload"></i> Import from file
            </button>
            <input #fileInput type="file" accept=".xlsx,.xls" style="display:none" (change)="onFileSelected($event)">
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Cost</th>
                <th>Reward Total</th>
                <th>Users Count</th>
                <th>Rewards</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="10" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else {
                @for (tournament of tournaments; track tournament.tournamentId; let i = $index) {
                  <tr>
                    <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>{{ getTournamentTypeName(tournament.type) }}</td>
                    <td>{{ dateService.getDateFromatted(tournament.startDateTimestamp) }}</td>
                    <td>{{ dateService.getDateFromatted(tournament.endDateTimestamp) }}</td>
                    <td>{{ tournament.costQuantity }}</td>
                    <td>{{ tournament.rewardTotalQuantity }}</td>
                    <td>{{ tournament.usersCount }}</td>
                    <td>{{ tournament.rewards.length }}</td>
                    <td>
                      @switch (getTournamentStatus(tournament)) {
                        @case ('waiting') {
                          <span class="badge bg-info">Waiting</span>
                        }
                        @case ('in_progress') {
                          <span class="badge bg-success">In progress</span>
                        }
                        @case ('past') {
                          <span class="badge bg-danger">Past</span>
                        }
                      }
                    </td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickUsers(tournament)" tooltip="Users" placement="top"><i class="fa fa-users"></i></button>
                      <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(tournament)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(tournament)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + tournaments.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="pageNumber >= totalPages">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
        </tab>
        <tab heading="Configurations">
          <app-configurations-block [configurations]="tournamentConfigurations" [collapsible]="false" />
        </tab>
      </tabset>
    </div>
  </div>
</div>

<app-tournament-add-modal #addModal></app-tournament-add-modal>
<app-tournament-edit-modal #editModal></app-tournament-edit-modal>
<app-tournament-users-modal #usersModal></app-tournament-users-modal>
